import { Cascader, Radio } from 'antd'
import React, { useLayoutEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import langOptions, { getCodeValue } from '../../../data/languageCascaderData'
import { PackageInfo, PackageInfoForm } from '../../../types'

type PackLangSelectProp = {
  packageInfo: PackageInfoForm
  setPackageInfo: (packageInfo: PackageInfoForm) => void
}
const PackLangSelect = ({
  packageInfo,
  setPackageInfo,
}: PackLangSelectProp) => {
  const [isImageOnly, setIsImageOnly] = useState(false)
  useLayoutEffect(() => {
    packageInfo.textLang === 'IMAGE_ONLY'
      ? setIsImageOnly(true)
      : setIsImageOnly(false)
  }, [packageInfo])
  const [beforeSelectedLang, setBeforeSelectedLang] = useState(
    packageInfo.textLang,
  )
  return (
    <div className="creation-pack-with-type-pack-extrainfo">
      <div className="creation-pack-with-type-pack-extrainfo-label-box">
        <div className="creation-pack-with-type-pack-extrainfo-label">
          <span style={{ color: 'red' }}>*</span>
          <FormattedMessage
            id="Upload.PkgCreation.createPack.packLanguage.selection"
            defaultMessage="Pack Language Selection"
          />
        </div>
      </div>

      <div className="creation-pack-with-type-pack-language-value">
        <div className="creation-pack-with-type-pack-language-selection">
          <Radio.Group
            onChange={(e) => {
              if (e.target.value === 'IMAGE_ONLY') {
                setPackageInfo({
                  ...packageInfo,
                  textLang: e.target.value,
                })
                setIsImageOnly(true)
                return
              }
              setIsImageOnly(false)
            }}
            value={isImageOnly ? 'IMAGE_ONLY' : 'text'}
          >
            <Radio value={'IMAGE_ONLY'}>
              <FormattedMessage
                id="Upload.PkgCreation.createPack.packLanguage.imageOnly"
                defaultMessage="No Text"
              />
            </Radio>
            <Radio value={'text'} style={{ marginLeft: '82px' }}>
              <FormattedMessage
                id="Upload.PkgCreation.createPack.packLanguage.include"
                defaultMessage="With Text"
              />
            </Radio>
          </Radio.Group>
          <Cascader
            placeholder="Languages"
            fieldNames={{
              label: 'language',
              value: 'code',
              children: 'others',
            }}
            allowClear={false}
            className="creation-pack-with-type-cascader-language-selection"
            popupClassName="creation-pack-with-type-cascader-language-selection-popup"
            options={langOptions}
            value={
              packageInfo.textLang === 'IMAGE_ONLY'
                ? getCodeValue(beforeSelectedLang)
                : getCodeValue(packageInfo.textLang)
            }
            displayRender={(labels, selectedOptions) => {
              return labels.map((label, i) => {
                if (!selectedOptions) {
                  return <></>
                }
                const option = selectedOptions[i]
                console.log('selected', option)
                if (option.code === 'others') {
                  return ''
                }

                return <span key={option.code}>{label}</span>
              })
            }}
            onChange={(textLang) => {
              setBeforeSelectedLang(textLang[0])
              setPackageInfo({ ...packageInfo, textLang: textLang[0] })
            }}
            disabled={isImageOnly ? true : false}
          />
        </div>
        <div className="creation-pack-with-type-pack-value-caution">
          <span style={{ color: '#FF6060' }}>*</span>
          <FormattedMessage
            id="Upload.PkgCreation.createPack.packLanguage.caution"
            defaultMessage="If any sticker in the pack includes text, please select the language."
          />
        </div>
      </div>
    </div>
  )
}

export default PackLangSelect
